function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.618 1.502c1.361.03 2.633.543 3.58 1.61.941 1.059 1.352 2.359 1.297 3.713-.058 1.448-.643 2.955-1.67 4.312-.439.58-.97 1.206-1.581 1.873a48.275 48.275 0 01-1.557 1.613 80.224 80.224 0 01-2.944 2.766h0L10.2 18.76l-1.14-.682-1.393-1.27a92.672 92.672 0 01-2.306-2.205c-.412-.409-.804-.806-1.171-1.192a31.762 31.762 0 01-2-2.27C1.153 9.824.565 8.324.505 6.872c-.056-1.368.36-2.69 1.31-3.76.946-1.066 2.22-1.58 3.556-1.61 1.434-.032 2.936.49 4.196 1.482 2.004-.986 3.578-1.514 5.05-1.482z",
  fillRule: "nonzero",
  stroke: "currentColor",
  fill: "none"
});
function SvgHeartDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgHeartDefault;